import ContentPicker from './ContentPicker.vue'

export default ContentPicker
